





































































































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import PageHeader from '../../../components/vui-luma/Ui/PageHeader.vue';
import PageSeparator from '../../../components/vui-luma/Ui/PageSeparator.vue';
import CustomSelectInput from '../../../components/vui-luma/Ui/CustomSelectInput.vue';
import MdIcon from '../../../components/vui-luma/Ui/MdIcon.vue';
import { dispatchGetUsersImportsList, dispatchSaveUsersImport, dispatchStartUsersImport } from '@/store/staff/actions';
import { readUsersImportsList } from '@/store/staff/getters';
import { IUsersImportList } from '@/interfaces/staff';

@Component({
  components: {
    PageHeader,
    PageSeparator,
    MdIcon,
    CustomSelectInput,
  },
})
export default class UsersImports extends Vue {
  public userImportObj: IUsersImportList | null = null;
  public perPage = 10;
  public currentPage = 1;
  public addModalVisible = false;
  public resultModalVisible = false;
  public file: any = null;
  public loadingState: any = {
    list: false,
    add: false,
    startImport: false,
  };

  public async mounted() {
    this.loadingState.list = true;
    await dispatchGetUsersImportsList(this.$store);
    this.loadingState.list = false;
  }

  get usersImportsList() {
    return readUsersImportsList(this.$store);
  }

  public rows() {
    return this.usersImportsList.length;
  }

  public openAddModal() {
    this.addModalVisible = true;
  }

  public closeAddModal() {
    this.addModalVisible = false;
    this.file = null;
  }

  public openResultModal(obj) {
    this.userImportObj = obj
    this.resultModalVisible = true;
  }

  public closeResultModal() {
    this.resultModalVisible = false;
    this.userImportObj = null;
  }

  public async validateForm() {
    let isValid = true;
    if (!this.file) {
      isValid = false;
    }
    return isValid;
  }

  public async submitAddForm() {
    this.loadingState.add = true;
    if (await this.validateForm()) {
      const formData = new FormData();
      
      formData.append('file_type', 'csv');
      formData.append('file', this.file);

      await dispatchSaveUsersImport(
        this.$store,
        formData,
      );
      
      this.closeAddModal();
    }
    this.loadingState.add = false;
  }

  public async startUsersImport(obj) {
    if (confirm(`${this.$t('Start import')}?`)) {
      this.userImportObj = obj;
      this.loadingState.startImport = true;
      await dispatchStartUsersImport(
        this.$store,
        {import_id: obj.id, create_users: true},
      );
      this.userImportObj = null;
      this.loadingState.startImport = false;
    }
  }

  public async startPreUsersImport(obj) {
    if (confirm(`${this.$t('Start preview import')}?`)) {
      this.userImportObj = obj;
      this.loadingState.startImport = true;
      await dispatchStartUsersImport(
        this.$store,
        {import_id: obj.id, create_users: false},
      );
      this.userImportObj = null;
      this.loadingState.startImport = false;
    }
  }

  get fieldsNames() {
    return [
      {
        key: 'id',
        // @ts-ignore
        label: this.$t('ID'),
        sortable: true,
        thClass: 'text-right',
        tdClass: 'text-right',
      }, {
        key: 'filename',
        // @ts-ignore
        label: this.$t('Filename'),
        sortable: true,
        thClass: 'text-right',
        tdClass: 'text-right',
      }, {
        key: 'file_type',
        // @ts-ignore
        label: this.$t('Type'),
        thClass: 'text-right',
        tdClass: 'text-right',
      }, {
        key: 'status_display',
        // @ts-ignore
        label: this.$t('Status'),
        sortable: true,
        thClass: 'text-right',
        tdClass: 'text-right',
      }, {
        key: 'params',
        label: '',
        thClass: 'text-right',
        tdClass: 'text-right',
      },
    ];
  }
  
}
